import React, { useContext } from 'react';

import DocumentContext from '../DocumentPage/DocumentContext';
import { GoogleAdsTemplate } from './GoogleAdsTemplate';

type Props = {
    idSuffix: string;
};

export const AdsPrimaryMobile: React.FC<Props> = ({ idSuffix }) => {
    const {
        publisher: {
            licenses: { docpageAds },
        },
    } = useContext(DocumentContext);

    return (
        <GoogleAdsTemplate
            adSizes={[[320, 50]]}
            idSuffix={idSuffix}
            isShowInnerTitle={true}
            network={
                docpageAds
                    ? '/30443627/DocPage_PrimaryMobExp_adConnect_2'
                    : '/30443627/DocPage_PrimaryMobExp'
            }
        />
    );
};
